"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceHyphens = exports.formatPrice = exports.formatPhoneNumber = exports.capitalize = void 0;
var capitalize_1 = require("./capitalize");
Object.defineProperty(exports, "capitalize", { enumerable: true, get: function () { return __importDefault(capitalize_1).default; } });
var formatPhoneNumber_1 = require("./formatPhoneNumber");
Object.defineProperty(exports, "formatPhoneNumber", { enumerable: true, get: function () { return __importDefault(formatPhoneNumber_1).default; } });
var formatPrice_1 = require("./formatPrice");
Object.defineProperty(exports, "formatPrice", { enumerable: true, get: function () { return __importDefault(formatPrice_1).default; } });
var replaceHyphens_1 = require("./replaceHyphens");
Object.defineProperty(exports, "replaceHyphens", { enumerable: true, get: function () { return __importDefault(replaceHyphens_1).default; } });
//# sourceMappingURL=index.js.map